<template>
  <div>
    <div id="admin-preloader" v-if="loading">
      <div id="admin-loader-text">Updating</div>
      <div id="admin-loader"></div>
    </div>
    <div id="admin-preloader" v-if="loading1">
      <div id="admin-loader-text">Loading</div>
      <div id="admin-loader"></div>
    </div>
    <div v-if="changed">
      <div class="container mt-5">
        <h3 class="m-auto text-info text-center pb-4">Setting</h3>
        <div class="col-sm-12 col-lg-8 m-auto mt-4 bg-white py-4">
          <el-form
            :model="setting"
            ref="setting"
            label-width="200px"
            :label-position="label"
            size="medium"
            status-icon
            @submit.native.prevent
          >
            <el-form-item label="Print Paper Size" prop="printSize">
              <el-select
                v-model="setting.printSize"
                placeholder="Print Paper Size"
              >
                <el-option
                  v-for="item in printSizes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="Show/Hide Browser Print Popup"
              prop="printPopup"
            >
              <el-select
                v-model="setting.printPopup"
                placeholder="Show/Hide Browser Print Popup"
              >
                <el-option
                  v-for="item in printPopupMode"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Enable Print Only Button" prop="printOnly">
              <el-checkbox v-model="setting.printOnly"
                >Enable Print Only Button</el-checkbox
              >
            </el-form-item>

            <!-- <el-form-item label="Default Payment Method" prop="defaultPay">
              <el-select
                v-model="setting.defaultPay"
                placeholder="Default Payment Method"
              >
                <el-option
                  v-for="item in defaultPayOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item> -->

            <el-form-item label="Tax Calculation Mode" prop="taxMode">
              <el-select
                v-model="setting.taxMode"
                placeholder="Tax Calculation Mode"
              >
                <el-option
                  v-for="item in discountModes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="Service Charge Calculation Mode" prop="serviceChargeMode">
              <el-select
                v-model="setting.serviceChargeMode"
                placeholder="Service Charge Calculation Mode"
              >
                <el-option
                  v-for="item in discountModes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item
              label="Low Stock Alert Quantity"
              prop="lowStockAlertQuantity"
            >
              <el-input-number
                v-model="setting.lowStockAlertQuantity"
                controls-position="right"
                @change="handleChange"
                :min="1"
              ></el-input-number>
            </el-form-item> -->
            
            <el-form-item
              label="Digits for Invoice No"
              prop="invoDigits"
            >
              <el-select
                v-model="setting.invoDigits"
                placeholder="Digits for Invoice No"
              >
                <el-option
                  v-for="item in invoDigitsOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              label="Loyalty Points per LKR 1000"
              prop="loyalityPoints"
            >
              <el-input-number
                v-model="setting.loyalityPoints"
                controls-position="right"
                @change="handleChange"
                :min="0"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="Referrals Points per LKR 1000"
              prop="referralPoints"
            >
              <el-input-number
                v-model="setting.referralPoints"
                controls-position="right"
                @change="handleChange"
                :min="0"
              ></el-input-number>
            </el-form-item>

            <el-form-item
              label="Invoice Options to Enable"
            >
              <el-checkbox-group v-model="setting.invoOptions">
                <el-checkbox
                  v-for="option in invoOptionsList"
                  :label="option"
                  :key="option"
                  >{{ option }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
            <!-- <el-form-item label="Invoice Header Content" prop="header">
              <el-input
                type="textarea"
                maxlength="200"
                show-word-limit
                v-model="setting.header"
                placeholder="Header Content"
              ></el-input>
            </el-form-item> -->
            <el-form-item label="Invoice Footer Content" prop="footer">
              <el-input
                type="textarea"
                maxlength="450"
                show-word-limit
                v-model="setting.footer"
                placeholder="Footer Content"
              ></el-input>
            </el-form-item>

            <el-form-item label="Upload Store Logo">
              <el-upload
                class="upload-demo"
                :auto-upload="false"
                :multiple="false"
                :limit="1"
                action="/"
                ref="upload"
                :on-change="fileSelect1"
              >
                <el-button slot="trigger" size="small" type="success"
                  >select file</el-button
                >
                <div class="el-upload__tip" slot="tip">
                  jpg/png files with a size less than 500kb
                </div>
              </el-upload>
            </el-form-item>

            <el-form-item label="Uploaded Logo" prop="logo">
              <img :src="image1" alt="" width="240px" height="80px" />
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="upDet('setting')"
                >Update Setting</el-button
              >
              <el-button type="warning" @click="resetPassword"
                >Reset Password</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageCompressor from "image-compressor.js";
import db from "../../config/FirebaseInit";
import firebase from "firebase/app";
import {
  GeoCollectionReference,
  GeoFirestore,
  GeoQuery,
  GeoQuerySnapshot,
} from "geofirestore";
import "firebase/firestore";
export default {
  name: "setting",
  data() {
    return {
      setting: {
        printSize: "",
        printPopup: true,
        // discountMode: "",
        taxMode: "Percentage",
        serviceChargeMode: "Percentage",
        // lowStockAlertQuantity: 1,
        loyalityPoints: 0,
        referralPoints: 0,
        // header: "",
        footer: "",
        printOnly: true,
        invoOptions: [],
        invoDigits: 8,
        defaultPay: 'Cash'
      },
      invoOptionsList: [
        "Card Payment", "Cheque Payment", "Gift Vouchers", "Loyalty Points","Service Charge","Tax", "Delivery Charge",
      ],
      printSizes: [
        {
          value: "A4",
          label: "A4",
        },
        {
          value: "A5",
          label: "A5",
        },
        {
          value: "POS Printer 58 mm Paper",
          label: "POS Printer 58 mm Paper",
        },
        {
          value: "POS Printer 80 mm Paper",
          label: "POS Printer 80 mm Paper",
        },
      ],
      discountModes: [
        {
          value: "Percentage",
          label: "Percentage %",
        },
        {
          value: "Amount",
          label: "Amount",
        },
      ],
      defaultPayOptions: [
        {
          value: "Cash",
          label: "Cash",
        },
        {
          value: "Card",
          label: "Card",
        },
      ],
      printPopupMode: [
        {
          value: true,
          label: "Show Popup",
        },
        {
          value: false,
          label: "Hide Popup",
        },
      ],
      invoDigitsOptions: [ {value:8, label:8,}, {value:10, label:10,}],
      shops: [],
      stores: [],
      label: "",
      image1: "",
      loading1: false,
      loading: false,
      changed: true,
    };
  },

  methods: {
    backToTop: function () {
      $("html,body").stop().animate(
        {
          scrollTop: 0,
        },
        "fast",
        "swing"
      );
    },

    handleChange() {},
    clearFiles() {
      this.$refs.upload.clearFiles();
    },
    fileSelect1(event) {
      // console.log("event is", event);
      const files = [];
      files[0] = event.raw;
      let filename = files[0].name;
      if (
        files[0].type !== "image/png" &&
        files[0].type !== "image/jpeg" &&
        files[0].type !== "image/jpg"
      ) {
        alert(
          "File " +
            files[0].name +
            " is not type of jpeg or jpg or png!. You cannot upload other types of images."
        );
        this.clearFiles();
      } else if (files[0].size > 500200) {
        alert(
          "File " +
            files[0].name +
            " is too large! maximum file size should be 500 kb"
        );
        this.clearFiles();
      } else {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          this.visible = "none";
          this.image = reader.result;
          this.visible1 = "block";
        });
        reader.readAsDataURL(files[0]);
        //this.image = files[0];
        const imageCompressor = new ImageCompressor();
        imageCompressor
          .compress(files[0], { quality: 0.4 })
          .then((result) => {
            // Handle the compressed image file.
            if (result.size > 100000) {
              const imageCompressor = new ImageCompressor();
              imageCompressor
                .compress(result, { quality: 0.6, width: 720, height: 140 })
                .then((result) => {
                  const fileReader = new FileReader();

                  // This fires after the blob has been read/loaded.
                  fileReader.addEventListener("load", () => {
                    this.image1 = fileReader.result;

                    // console.log("image is", this.image1);
                  });

                  // Start reading the blob as text.
                  fileReader.readAsDataURL(result);

                  ////console.log(filename)
                  // console.log(result.size);
                  //console.log('image is',result)
                });
            } else {
              var fileReader = new FileReader();
              fileReader.addEventListener("load", () => {
                this.image1 = fileReader.result;

                // console.log("else image is", this.image1);
              });
              fileReader.readAsDataURL(result);
              ////console.log(filename)
              // console.log("else", result.size);
              //console.log('ekse image is',result)
            }
          })

          .catch((err) => {
            // Handle the error
            //console.log("error is" + err)
          });
      }
    },
    resetPassword() {
      firebase
        .auth()
        .sendPasswordResetEmail(this.shops[0].regemail)
        .then(() => {
          // Password reset email sent!
          this.$notify({
            title: "Success",
            message: "Password reset link is sent to your email",
            type: "success",
          });
        })
        .catch((error) => {
          alert(error.message);
        });
    },
    upDet(cdata) {
      this.$refs[cdata].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.changed = false;
          this.backToTop();
          // const firestore = firebase.firestore();
          // Create a GeoFirestore reference
          //const geofirestore = new GeoFirestore(firestore);
          // Create a GeoCollection reference
          //const geoshop = geofirestore.collection('shops').doc(this.shops[0].id);
          //console.log('uid',firebase.auth().currentUser.uid)
          // geoshop
          // .update({
          //   details: {
          //     stime: this.setting.startTime,
          //     etime: this.setting.endTime,
          //     tel1: this.setting.phone1,
          //     tel2: this.setting.phone2,
          //     address: this.setting.address,
          //     email: this.setting.email,
          //     name:this.shops[0].name,
          //     perm:'allowed'
          //     //  lat: this.setting.lat,
          //     //  lng: this.setting.long
          //   },
          //   cat:this.shops[0].cat,
          //   coordinates: new firebase.firestore.GeoPoint(this.setting.lat, this.setting.long)
          // })
          //  .then(doc => {
          this.$store.state.secondaryDatabase
            .collection("stores")
            .doc(this.$store.state.selectedStore)
            .update({
              setting: this.setting,
              logo: this.image1,
              //coordinates: new firebase.firestore.GeoPoint(this.setting.lat, this.setting.long)
            })
            .then(() => {
              this.loading = false;
              this.changed = true;
              this.$notify({
                title: "Success",
                message: "Settings updated",
                type: "success",
              });
            })
            .catch((error) => console.log(error));
          //console.log('doc is', doc)
          //})
          // .catch(error => alert(error));
        } else {
          alert("error update!!!");
          return false;
        }
      });
    },
    getStoreData(id) {
      this.$store.state.secondaryDatabase
        .collection("stores")
        .doc(id)
        .get()
        .then((doc) => {
          const data = {
            id: doc.id,
            setting: doc.data().setting || {},
            logo: doc.data().logo,
          };
          this.stores.push(data);
          this.setting.printSize = data.setting.printSize;
          this.setting.printPopup = data.setting.printPopup;
          this.setting.taxMode = data.setting.taxMode;
          this.setting.invoOptions = data.setting.invoOptions || [];
          this.setting.invoDigits = data.setting.invoDigits || 8;
          this.setting.serviceChargeMode = data.setting.serviceChargeMode || 'Percentage';
          // this.setting.discountMode = data.setting.discountMode;
          // this.setting.lowStockAlertQuantity =
          //   data.setting.lowStockAlertQuantity;
          this.setting.referralPoints = data.setting.referralPoints;
          this.setting.loyalityPoints = data.setting.loyalityPoints;
          // this.setting.header = data.setting.header;
          this.setting.footer = data.setting.footer;
          this.setting.printOnly = data.setting.printOnly;
          this.setting.defaultPay = data.setting.defaultPay || 'Cash';
          this.image1 = data.logo || "";
          this.loading1 = false;
          this.changed = true;
        })
        .catch((error) => alert(error.message));
    },
  },
  mounted() {
    this.$root.$on("storeChange", (store) => {
      this.$store.state.selectedStore = store;
      this.loading1 = true;
      this.changed = false;
      this.getStoreData(this.$store.state.selectedStore);
    });
  },
  created() {
    //console.log('screen',screen.width)
    if (screen.width > 575) {
      this.label = "right";
    } else {
      this.label = "top";
    }
    this.backToTop();
    this.loading1 = true;
    this.changed = false;
    this.$store.state.secondaryDatabase
      .collection("shops")
      .where("owner", "==", firebase.auth().currentUser.uid)
      .get()
      .then((querySnapshot) => {
        this.shops = [];
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            setting: doc.data().setting || {},
            logo: doc.data().logo,
            regemail: doc.data().regemail,
          };
          this.shops.push(data);

          //console.log('shop coordinates',this.shops[0].coordinates)

          //console.log('doc is',doc)
        });
        this.getStoreData(this.$store.state.selectedStore);

        //console.log('querySnapshot is',querySnapshot)
        //console.log('querySnapshot data',querySnapshot.docs[0].data().details)
      })
      .catch((error) => alert(error));

    // if (navigator.geolocation) {
    //     navigator.geolocation.getCurrentPosition( (position) => {
    //          this.setting.lat = position.coords.latitude
    //          this.setting.long = position.coords.longitude
    //     }, (error) => {
    //         if(error.code == 0){
    //           alert('Unknown error occurred.');
    //           this.fetched = true
    //         }else if(error.code == 1){
    //           alert('Permission denied. You cannot find near by ' + this.value + ' until you allow to access your loocation.')
    //           this.fetched = true
    //         }else if(error.code == 2){
    //           alert('Position unavailable. Error response from location provider.')
    //           this.fetched = true
    //         }else if(error.code == 3){
    //           alert('Location data request timed out.')
    //           this.fetched = true
    //         }})
    //     //  //console.log('this.setting.lat', this.setting.lat)
    //     //   //console.log('this.setting.lat', position.coords.latitude)
    // } else {
    //    alert("Geolocation is not supported by this browser.")
    // }

    // function showPosition(position) {
    //    this.setting.lat = position.coords.latitude
    //    this.setting.long = position.coords.longitude
    // }
  },
};
</script>

<style scoped>
@import url("~@/assets/admin/css/admin-loader.css");
</style>



// WEBPACK FOOTER //
// src/components/admin/Setting.vue